import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CContainer,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
  CImage,
  CTooltip,
  CCollapse,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { useNavigate } from 'react-router-dom';
import { cilMenu } from '@coreui/icons';
import UserDropdown from './typescript/UserDropdown';
import { t } from 'i18next';

import assistence from '@assets/images/headphone-assistence.png';
import shoppingBag from '@assets/images/shopping-bag_6459341.png';
import coinHst from '@assets/images/coin_hst.png';
import hostybleIcon from '@assets/images/hostyble.jpg';

import { CreditsContext } from '@utils/GlobalContext.js';

const Header = () => {
  const creditsCtx = useContext(CreditsContext);
  const headerRef = useRef()
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const navigate = useNavigate()
  const [showSupport, setShowSupport] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0);
      }
    };
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <CHeader position="sticky" className="mb-4 p-0" ref={headerRef}>
      <CContainer className="border-bottom px-4" fluid>
        <CHeaderToggler
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
          style={{ marginInlineStart: '-14px' }}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>

        <CHeaderNav className="ms-auto d-flex align-items-center gap-4 position-relative">
          {/* SHOP */}
          <CNavItem>
            <CTooltip content="Shop" placement="bottom">
              <CNavLink onClick={() => navigate('/prices-plans')} className="p-0 icon-link">
                <CImage src={shoppingBag} width={32} height={32} className="menu-icon" />
              </CNavLink>
            </CTooltip>
          </CNavItem>

          {/* ASSISTENZA */}
          <CNavItem className="position-relative">
            <CTooltip content="Assistenza" placement="bottom">
              <CNavLink className="p-0 icon-link" onClick={() => setShowSupport((prev) => !prev)}>
                <CImage src={assistence} width={32} height={32} className="menu-icon" />
              </CNavLink>
            </CTooltip>

            <CCollapse visible={showSupport} className="position-absolute top-100 end-0 mt-2">
              <div className="support-box shadow rounded-3 p-3 bg-white border">
                <p className="m-0 fw-semibold">{t('label.client_support')}</p>
                <a
                  href="mailto:hostyble@sterz.it?subject=Support Request - Hostyble Web"
                  rel="noopener noreferrer"
                  className="text-primary text-decoration-none small"
                  onClick={(e) => e.stopPropagation()}
                >
                  hostyble@sterz.it
                </a>
              </div>
            </CCollapse>
          </CNavItem>

          {/* HOSTYBLE - active accomodations */}
          <CNavItem className="d-flex align-items-center">
            <CTooltip content="Hostyble" placement="bottom">
              <div className="group-nav-item d-flex align-items-center">
                <CNavLink className="p-0 icon-link">
                  <CImage src={hostybleIcon} width={32} height={32} className="menu-icon" />
                </CNavLink>
                <span className="credit-counter ms-2 px-2 py-1 rounded-pill fw-semibold">
                  {creditsCtx?.activeAccomodation ?? 0}
                </span>
              </div>
            </CTooltip>
          </CNavItem>

          {/* COIN CREDITI */}
          <CNavItem className="d-flex align-items-center">
            <CTooltip
              content={`Scadenza: ${creditsCtx?.expirationDate?.split('T')[0] ?? ''}`}
              placement="bottom"
            >
              <div className="group-nav-item d-flex align-items-center">
                <CNavLink className="p-0 icon-link">
                  <CImage src={coinHst} width={32} height={32} className="menu-icon" />
                </CNavLink>
                <span className="credit-counter ms-2 px-2 py-1 rounded-pill fw-semibold">
                  {creditsCtx?.creditsRemain ?? 0}
                </span>
              </div>
            </CTooltip>
          </CNavItem>
        </CHeaderNav>

        <CHeaderNav>
          <li className="nav-item py-1">
            <div className="vr h-100 mx-2 text-body text-opacity-75" />
          </li>
          <UserDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default Header;